module.exports = __webpack_public_path__ + "img/header-left2.3a5a0041.jpg";